import { Skeleton } from '@wwe-portal/ui/components/skeleton';

import { OfferCardTypeEnum } from '@wwe-portal/entities/offer.type';

import { OfferGridGeneric } from './offer-grid-generic';

const CardSkeleton = () => (
  <div className="aspect-single-1 relative w-full">
    <Skeleton className="absolute inset-0" />
  </div>
);
export const OfferGridSkeleton: React.FC<{ total: number }> = ({ total }) => {
  return (
    <OfferGridGeneric
      CardComponent={CardSkeleton}
      getKey={(item) => item.id}
      offers={new Array(total).fill(0).map((_, id) => ({
        id: String(id),
        type: OfferCardTypeEnum.SINGLE1 as OfferCardTypeEnum,
      }))}
    />
  );
};
